import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-storage',
    templateUrl: './storage.component.html',
    styleUrls: ['./storage.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StorageComponent {
}
